import {Component} from '@angular/core';
import {AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators} from '@angular/forms';
import {catchError, EMPTY, Subscription} from 'rxjs';
import {GgAuthService} from '../../services/gg-auth.service';
import {AuthService} from '../../../../services/api/auth.service';
import {AlertService} from '../../../../services/notify/alert.service';
import {TokenService} from '../../../../services/token.service';
import {TFormState} from '../../../../models/forms.model';
import {Router} from '@angular/router';

@Component({
    selector: 'app-gg-activate-form',
    templateUrl: './gg-activate-form.component.html',
    styleUrl: './gg-activate-form.component.scss'
})
export class AppGgActivateFormComponent {
    subscriptions = new Subscription;
    public activateForm: FormGroup;
    public hidePassword: Boolean = true;
    public formState: TFormState = 'Default';
    lastPage: string = '';

    constructor(
        private fb: FormBuilder,
        private ggAuthService: GgAuthService,
        private authService: AuthService,
        private alertService: AlertService,
        private tokenService: TokenService,
        private router: Router
    ) {
        this.activateForm = fb.group({
            email: ['', {validators: [Validators.required, Validators.email]}],
            passwd: ['', {validators: [Validators.required, Validators.minLength(8)]}],
            passwd2: [''],
            firstname: ['', {validators: [Validators.required]}],
            lastname: ['', {validators: [Validators.required]}],
            middlename: [''],
            invite_code: ['', {validators: [Validators.required]}]
        });
    }

    ngOnInit(): void {
        this.password2?.addValidators([Validators.required, Validators.minLength(8), this.comparePasswordValidator()]);
    }

    replaceAsteriks(s: string) {
        return s && s.replace('*', '');
    }

    activateAccount() {
        this.formState = 'Submitting';
        this.authService.register(this.activateForm.value)
            .pipe(
                catchError(err => {
                    this.alertService.setAlert(err.message, 'blue');
                    this.formState = 'Default';
                    return EMPTY;
                }))
            .subscribe(data => {
                this.formState = 'Default';
                this.alertService.setAlert(data.message, 'green');
                this.tokenService.setToken(data.access_token, data.expires_in);
                this.router.navigate(['account', 'tasks', 'all']);
            });
    }

    comparePasswordValidator(): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            return (this.password2?.value === this.password?.value ? null : {passowrdDifference: true});
        };
    }

    goToLoginPage() {
        this.ggAuthService.loginStateSub.next({state: 'login'});
    }

    get email() {
        return this.activateForm.get('email');
    }

    get password() {
        return this.activateForm.get('passwd');
    }

    get password2() {
        return this.activateForm.get('passwd2');
    }

    get firstname() {
        return this.activateForm.get('firstname');
    }

    get lastname() {
        return this.activateForm.get('lastname');
    }

    get invite_code() {
        return this.activateForm.get('invite_code');
    }
}
